import React from 'react';

import PropTypes from 'prop-types';

import { parseSearch } from '@src/utils/urlHelpers';

export class LoginCheck extends React.PureComponent {
    static propTypes = {
        children: PropTypes.node,
    };

    tokenParamsPresent() {
        const params = parseSearch(location.search);

        return (params.t || params.agent_jwt);
    }

    checkIfTokenIsInURL() {
        const params = parseSearch(location.search);

        const usersCurrentUrl = this.getUserCurrentPath(location);

        /*
        * Check if the user has a token:
        * apply that token to local storage
        * then refresh the page, removing token from URL
        * else redirect to welcome page
        */

        if (params.t) {
            window.localStorage.setItem('jwt', params.t);
            window.location.replace(usersCurrentUrl);
        } else if (params.admin_jwt && params.agent_jwt) {
            // impersonate tokens
            window.localStorage.setItem('jwt', params.agent_jwt);
            window.localStorage.setItem('admin_jwt', params.admin_jwt);
            window.localStorage.setItem('agent_jwt', params.agent_jwt);
            window.location.replace('/');
        } else {
            window.location.replace(`/welcome?redirect_to=${window.location.href}`);
        }
    }

    getUserCurrentPath = ({
        origin,
        pathname,
        search,
    }) => {
        const searchParam = search.split('?t=');

        return `${origin}${pathname}${searchParam[0]}`;
    };

    render() {
        /**
        * Check if user has a token in local storage or has token param
        * else you need to retrieve/establish one
        **/
        if (!window.localStorage.getItem('jwt') || this.tokenParamsPresent()) {
            return (
                <div>
                    { this.checkIfTokenIsInURL() }
                </div>
            );
        }

        return this.props.children;
    }
}

export default LoginCheck;
